import { runInAction, makeAutoObservable } from "../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 26957, offsets 191631:193529. Structure and names inferred from code, not screenshots.
import { module96822 as processShim } from "../vendor/dependencies.js";
function a(e, t, i) {
  return (
    t in e
      ? Object.defineProperty(e, t, {
          value: i,
          enumerable: true,
          configurable: true,
          writable: true,
        })
      : (e[t] = i),
    e
  );
}
let r = "announce_banner_dismissed",
  l = "docs_sidebar_collapsed";
function s(e, t, i) {
  return (
    t in e
      ? Object.defineProperty(e, t, {
          value: i,
          enumerable: true,
          configurable: true,
          writable: true,
        })
      : (e[t] = i),
    e
  );
}
let siteStore = new (class {
    async fetchQrUrls() {
      try {
        let e = await fetch("/external/qrs.json", {
          cache: "no-cache",
        });
        if (!e.ok) throw Error(`HTTP ${e.status}`);
        let t = await e.json(),
          i = {};
        for (let [e, n] of Object.entries(t)) i[e] = n.url;
        runInAction(() => {
          this.qrUrls = i;
        });
      } catch (e) {
        console.error("获取 QR 码 URL 失败:", e);
      }
    }
    initShowBanner() {
      if ("u" < typeof localStorage) return;
      let e = localStorage.getItem(r);
      runInAction(() => {
        this.showBanner = !e;
      });
    }
    initDocsSidebarCollapsed() {
      if ("u" < typeof localStorage) return;
      let e =
        "true" === localStorage.getItem(l) ||
        window.location.pathname.includes("price-comparison");
      runInAction(() => {
        this.docsSidebarCollapsed = e;
      });
    }
    setShowRateLimitPopup(e) {
      runInAction(() => {
        this.showRateLimitPopup = e;
      });
    }
    setShowBanner(e) {
      (runInAction(() => {
        this.showBanner = e;
      }),
        e ? localStorage.removeItem(r) : localStorage.setItem(r, "true"));
    }
    setDocsSidebarCollapsed(e) {
      (runInAction(() => {
        this.docsSidebarCollapsed = e;
      }),
        "u" > typeof localStorage &&
          (e ? localStorage.setItem(l, "true") : localStorage.removeItem(l)));
    }
    toggleDocsSidebarCollapsed() {
      this.setDocsSidebarCollapsed(!this.docsSidebarCollapsed);
    }
    constructor() {
      (a(this, "showBanner", true),
        a(this, "showRateLimitPopup", false),
        a(this, "docsSidebarCollapsed", false),
        a(this, "qrUrls", {}),
        makeAutoObservable(this),
        this.initShowBanner(),
        this.initDocsSidebarCollapsed(),
        processShim.env.IS_SSR || this.fetchQrUrls());
    }
  })(),
  inviteStore = new (class {
    constructor() {
      (s(this, "showInviteCodeModal", false),
        s(this, "openInviteCodeModal", () => {
          runInAction(() => {
            this.showInviteCodeModal = true;
          });
        }),
        s(this, "closeInviteCodeModal", () => {
          runInAction(() => {
            this.showInviteCodeModal = false;
          });
        }),
        makeAutoObservable(this));
    }
  })();
export { siteStore, inviteStore };
